import firebaseApp from "../firebase/credenciales";
import { getFirestore, collection, doc, updateDoc } from "firebase/firestore";
import Swal from 'sweetalert2'
import escribirLog from "./escribirLog";

async function añadirProducto(infoProducto, autor, baseDatos, id) {

  //console.log(infoProducto)
  const db = getFirestore(firebaseApp);
  const collectionRef = collection(db, baseDatos);

  // El DNI es el ID del documento en Firestore (o el ID pasado como argumento)
  const docId = id || infoProducto.dni;

  if (!docId || docId.trim() === '') {
    Swal.fire({
      icon: 'error',
      title: 'Error',
      text: 'No se pudo identificar el documento a editar. Falta DNI.',
    });
    return;
  }

  // Crear una copia del objeto sin el campo 'id' para evitar conflictos
  const { id: _, ...infoProductoSinId } = infoProducto;

  const docRef = doc(collectionRef, docId);

  try {
    await updateDoc(docRef, infoProductoSinId);

    //registro concluido
    Swal.fire({
      position: 'top-end',
      icon: 'success',
      title: 'Registro editado correctamente',
      showConfirmButton: false,
      timer: 1500
    });

    escribirLog("Edición", infoProductoSinId, autor);
  } catch (error) {
    console.error("Error al actualizar documento:", error);
    Swal.fire({
      icon: 'error',
      title: 'Error al actualizar',
      text: error.message,
    });
  }
}

export default añadirProducto;
